import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonModule, CheckboxModule, InputModule, RadioModule, SelectModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvoiceErrorInternationalForm, InvoiceErrorInternationalFormGroup } from '../../../models/cod-create.model';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { InvoiceIssueTypeDetail } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine } from '../../../state/cod.action';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-invoice-error-international-step',
    templateUrl: './invoice-error-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodInvoiceErrorInternationalStepComponent extends BaseInternationalStep {
    @Input() invoiceErrorInternationalForm: FormGroup<InvoiceErrorInternationalFormGroup> | undefined;

    public invoiceErrorDetailTypes = InvoiceIssueTypeDetail;

    constructor(private store: Store) {
        super();
    }

    public isDefined(control: keyof InvoiceErrorInternationalForm): boolean {
        return this.invoiceErrorInternationalForm?.controls[control].value !== null;
    }

    public isTrue(control: keyof InvoiceErrorInternationalForm): boolean {
        return this.invoiceErrorInternationalForm?.controls[control].value === true;
    }

    public isFalse(control: keyof InvoiceErrorInternationalForm): boolean {
        return this.invoiceErrorInternationalForm?.controls[control].value === false;
    }

    public handleConfirm() {
        if (this.invoiceErrorInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.invoiceErrorInternationalForm?.valid ?? false;
    }
}
